import React from "react";
import { GatsbyImage } from "gatsby-plugin-image";

const Sitemap = ({ simage, slug, area, citySlug }) => {
  return <GatsbyImage image={simage} alt="Site Map" />;
};

export default Sitemap;
